import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponsiveElementComponent } from './responsive-element.component';

@NgModule({
  declarations: [ResponsiveElementComponent],
  imports: [CommonModule],
  exports: [ResponsiveElementComponent],
})
export class ResponsiveElementModule {}
